import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import diacritics from 'diacritics';

export default {
  flowController: [
    'runtimeConstant',
    '$scope',
    '$state',
    '$rootScope',
    '$filter',
    '$window',
    '$uibModal',
    'flowService',
    'documentTypeCrudService',
    'folderService',
    'ETaskTypes',
    'authService',
    'PermPermissionStore',
    function (
      runtimeConstant,
      $scope,
      $state,
      $rootScope,
      $filter,
      $window,
      uibModal,
      flowService,
      documentTypeCrudService,
      folderService,
      ETaskTypes,
      authService,
      PermPermissionStore
    ) {
      'use strict';

      function onbeforeunload(e) {
        if ($scope.canEdit) {
          e.returnValue = $filter('translate')('ONBEFOREUNLOAD MESSAGE');
          return $filter('translate')('ONBEFOREUNLOAD MESSAGE');
        } else {
          return null;
        }
      }

      function flowData_filterDocumentTypes(item) {
        var filter = diacritics
          .remove($scope.flowData.documentTypeFilter)
          .toLowerCase();
        var name = diacritics.remove(item.name).toLowerCase();
        return name.indexOf(filter) > -1;
      }

      function filter(item) {
        return item.selected;
      }

      function hasUsers() {
        var l =
          $scope.extraTab.selectedElement &&
          $scope.extraTab.selectedElement.users
            ? $scope.extraTab.selectedElement.users.filter($scope.filter).length
            : 0;
        return l > 0;
      }

      function hasGroups() {
        var l =
          $scope.extraTab.selectedElement &&
          $scope.extraTab.selectedElement.groups
            ? $scope.extraTab.selectedElement.groups.filter($scope.filter)
                .length
            : 0;
        return l > 0;
      }

      function swimlaneHasPerson() {
        return (
          $scope.extraTab.selectedElement.PersonDocumentAuthor ||
          $scope.hasUsers() ||
          $scope.hasGroups()
        );
      }

      function hasDocTypesAssigned() {
        return ($scope.flowData.documentTypes &&
          $scope.flowData.documentTypes.filter($scope.filter).length > 0) ||
          ($scope.flowData.selectedFolders &&
            $scope.flowData.selectedFolders.length > 0)
          ? true
          : false;
      }

      function isSelectedElementValid() {
        if ($scope.extraTab && $scope.extraTab.selectedElement) {
          if ($scope.isNotification()) {
            return (
              $scope.extraTab.selectedElement.title &&
              ($scope.hasUsers() === true || $scope.hasGroups() === true)
            );
          } else if ($scope.isSwimlane()) {
            return $scope.swimlaneHasPerson();
          }
          var durationValid =
            $scope.extraTab.selectedElement.duration === undefined ||
            $scope.extraTab.selectedElement.duration === null ||
            $scope.extraTab.selectedElement.duration > 0;
          return (
            $scope.extraTab.selectedElement.attr('text/text') !== '' &&
            durationValid
          );
        } else {
          return true;
        }
      }

      function getExample(name) {
        var data = $scope.configs.examples[name];

        var fnGetAllIDs = function (data, fnIsID) {
          var lst = [];

          var fnTraverse = function (o) {
            for (var j = 0, len = o.data.length; j < len; j++) {
              lst.push(o.data[j].id);
            }
          };

          fnTraverse(data, function (k, v) {
            if (lst.indexOf(k) === -1 && fnIsID(k)) {
              lst.push(k);
            }
            if (lst.indexOf(v) === -1 && fnIsID(v)) {
              lst.push(v);
            }
          });

          return lst;
        };

        var lstIDs = fnGetAllIDs(data, function (item) {
          return item && typeof item === 'string' && item.length === 36;
        });

        var str = JSON.stringify(data);

        for (var x = 0; x < lstIDs.length; x++) {
          str = str.replace(new RegExp(lstIDs[x], 'g'), joint.util.uuid());
        }

        return JSON.parse(str);
      }

      function loadFlow() {
        $scope.loadingWorkflow = true;
        if ($scope.guid) {
          return flowService.loadByGuid($scope.guid, $scope.action);
        } else {
          return new Promise(function (resolve) {
            resolve({ GraphElements: $scope.getExample('checklist') });
          });
        }
      }

      function getSelection() {
        var lst = $scope.configs.graph.getElements();
        var lstLinks = $scope.configs.graph.getLinks();

        lst = lst.concat(lstLinks);

        for (var i = 0; i < lst.length; i++) {
          if (lst[i].prop('prop/data/highlight')) {
            return lst[i];
          }
        }
        return null;
      }

      function select(cellView) {
        var obj = $scope.getSelection();

        if (obj === cellView.model) {
          return;
        }

        $scope.unselect(false);

        cellView.highlight();
        cellView.model.prop('prop/data/highlight', true);

        $scope.$broadcast('selectionchange', [cellView.model]);
      }

      function unselect(dispatchEvent) {
        var obj = $scope.getSelection();
        if (obj) {
          obj.prop('prop/data/highlight', false);
          $scope.configs.paper.findViewByModel(obj).unhighlight();
          if (dispatchEvent === undefined || dispatchEvent === null) {
            dispatchEvent = true;
          }
          if (dispatchEvent) {
            $scope.$broadcast('selectionchange', [null]);
          }
        }
      }

      function validate() {
        var workflow = $scope.getWorkflow();

        if ($scope.canSave(workflow)) {
          swal.fire({
            title: $filter('translate')('VALIDATION PASSED'),
            icon: 'success',
          });
        }
      }

      function removeElement() {
        var obj = $scope.getSelection();

        if (!obj) {
          // eslint-disable-next-line no-console
          console.warn('[removeElement] Nenhum elemento selecionado. Abortando.');
          return;
        }

        var isStart =
          $scope.getElements(ETaskTypes.Start)[0].get('parent') === obj.id;
        var isLastStart =
          obj.prop('prop/data/type') === ETaskTypes.Start &&
          $scope.configs.elementsCount.starts === 1;
        var isLastEnd =
          obj.prop('prop/data/type') === ETaskTypes.End &&
          $scope.configs.elementsCount.ends === 1;
        var isLastSwimlane =
          obj.prop('prop/data/type') === 'swimlane' &&
          $scope.configs.elementsCount.swimlanes === 1;

        if (isStart || isLastStart || isLastEnd || isLastSwimlane) {
          swal.fire({
            title: 'Remover',
            text: 'Não foi possível remover (limite atingido)',
            icon: 'info',
          });
          // eslint-disable-next-line no-console
          console.warn('[removeElement] Não permitido remover este elemento.');
          return;
        }

        $scope.savePositions();
        $scope.remove(obj);
        $scope.loadPositions();
        $scope.unselect();
      };

      function addElement(type) {
        if (type === 'swimlane') {
          swal.fire({
            title: $filter('translate')('ADD SWIMLANE'),
            showConfirmButtonText: $filter('translate')('ADD'),
            input: 'text',
            inputValue:
              $filter('translate')('SWIMLANE') +
              ' ' +
              ($scope.configs.elementsCount.swimlanes + 1),
            inputValidator: function (value) {
              return new Promise(function (resolve, reject) {
                if (value && value.length <= 25) {
                  resolve();
                } else {
                  reject($filter('translate')('MAX SIZE MUST BE') + ' 25');
                }
              });
            },
            showCancelButton: true,
            allowOutsideClick: false,
            preConfirm: function (value) {
              return new Promise(function (resolve) {
                if (!value) {
                  return resolve();
                }
                var obj = $scope.addSwimlane(null, value);
                $scope.getConfig(obj.id).Name = obj.attr('text/text');

                resolve();
              });
            },
          });
        } else if (type === 'link') {
          var source = $scope.getSelection();

          if (source.attributes.prop.data.type === ETaskTypes.Decision) {
            var html = $scope.getHtml();
            swal.fire({
              title: 'Edit link',
              html: html,
              focusConfirm: false,
              preConfirm: () => {
                const name  = window.linkOptions.elements.swalLinkName.value;
                const color = window.linkOptions.elements.linkColor.value;
                if (!name || !color) {
                  // Esta função faz aparecer a mensagem embaixo do campo, sem lançar erro
                  swal.showValidationMessage(
                    $filter('translate')('LINK NAME AND COLOR ARE REQUIRED')
                  );
                  return false; // impede o fechamento
                }
                return [name, color]; // sucesso
              },
              showCancelButton: true,
            }).then((result) => {
              if (result.isConfirmed && result.value) {
                const [name, color] = result.value;
                const lnk = $scope.addLink(source, null, name, null, true);
                lnk.color = $scope.linkColors.find(c => c.name === color);
              }
            });
          } else {
            $scope.addLink();
          }
        } else {
          if (type === ETaskTypes.Notification) {
            var not = $scope.addNotification();
            not.title =
              $filter('translate')('NOTIFICATION') +
              ' ' +
              $scope.configs.elementsCount.notifications;
            return not;
          }

          var dict = [];

          dict[ETaskTypes.Task] = {
            default: 'NEW TASK',
            count: $scope.configs.elementsCount.tasks,
            func: 'addTask',
          };
          dict[ETaskTypes.Decision] = {
            default: 'NEW DECISION',
            count: $scope.configs.elementsCount.decisions,
            func: 'addDecision',
          };
          dict[ETaskTypes.End] = {
            default: 'NEW END',
            count: $scope.configs.elementsCount.ends,
            func: 'addEnd',
          };
          dict[ETaskTypes.ReleaseDocument] = {
            default: 'NEW RELEASE',
            count: $scope.configs.elementsCount.releases,
            func: 'addReleaseDocument',
          };

          var title = dict[type].default + ' ' + (dict[type].count + 1);

          var el = $scope[dict[type].func](null, title);
          var name = el.attr('text/text');

          $scope.getConfig(el.id).Name = name;
        }
      }

      function addSwimlane(id, text) {
        if (!text) {
          text = $filter('translate')('ADD SWIMLANE') +
                ($scope.configs.elementsCount.swimlanes + 1);
        }

        const options = {
          size: {
            width: $scope.configs.swimlaneSize.width,
            height: $scope.configs.swimlaneSize.height,
          },
          position: {
            x: $scope.configs.swimlaneSize.width *
              $scope.configs.elementsCount.swimlanes + 1,
            y: 0,
          },
          attrs: {
            '.body': {
              fill: 'white',
              'fill-opacity': 0,
              stroke: '#DDD',
              'stroke-width': 2,
              'pointer-events': 'all',
            },
            '.title': {
              fill: '#999',
              'font-size': 12,
              'pointer-events': 'all',
            },
            text: { text: text },
          }
        };

        if (id) {
          options.id = id;
        }

        var obj = new joint.shapes.basic.MySwimlane(options);

        obj.prop('prop/data/type', 'swimlane');
        obj.prop('prop/data/children', {});

        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.swimlanes++;

        setTimeout(() => {
          resizePaper();
        }, 0);

        $scope.loadPositions();

        const view = $scope.configs.paper.findViewByModel(obj);
        if (view) {
          $scope.select(view);
        } else {
          // eslint-disable-next-line no-console
          console.warn('[addSwimlane] findViewByModel retornou vazio');
        }

        return obj;
      }

      function addTask(id, text, position, parent) {
        const cfg = angular.copy($scope.taskConfig);

        if (id) {
          cfg.id = id;
          cfg.prop.data.id = id;
        } else {
          delete cfg.id;
          cfg.prop.data.id = joint.util.uuid();
        }

        cfg.attrs = cfg.attrs || {};
        cfg.attrs.text = cfg.attrs.text || {};
        cfg.attrs.text.text = text;
        cfg.prop.data.type = ETaskTypes.Task;

        cfg.position = position || {
          x: ($scope.configs.swimlaneSize.width  - cfg.size.width)  / 2,
          y: ($scope.configs.swimlaneSize.height - cfg.size.height) / 2
        };

        const obj = new joint.shapes.basic.Task(cfg);
        obj.attr('.removeTask/display', 'none');
        obj.attr('circle/display', 'none');

        if ($scope.configs.orientation === 'horizontal') {
          obj.rotate(90);
        }

        $scope.configs.graph.addCell(obj);
        obj.toFront();
        $scope.configs.elementsCount.tasks++;
        obj.prop('prop/data/parent', parent);
        $scope.$broadcast('elementadded', [obj]);

        const view = $scope.configs.paper.findViewByModel(obj);
        if (view) {
          $scope.select(view);
        }
        return obj;
      }

      function addDecision(id, text, position, parent) {
        const cfg = angular.copy($scope.decisionConfig);

        if (id) {
          cfg.id = id;
          cfg.prop.data.id = id;
        } else {
          cfg.prop.data.id = joint.util.uuid();
          cfg.id = cfg.prop.data.id;
        }

        cfg.attrs.text.text = text;

        if (position) {
          cfg.position = position;
        } else {
          var xSize = $scope.configs.swimlaneSize.width / 2 - cfg.size.width / 2;
          var ySize = $scope.configs.swimlaneSize.height / 2 - cfg.size.height / 2;

          cfg.position = { x: xSize, y: ySize };
        }

        var obj = new joint.shapes.basic.Decision(cfg);

        if ($scope.configs.orientation === 'horizontal') {
          obj.rotate(90);
        }

        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.decisions++;

        if (parent) {
          var parentCell = $scope.configs.graph.getCell(parent);
          if (parentCell) {
            parentCell.embed(obj);
          }
        }

        $scope.$broadcast('elementadded', [obj]);

        $scope.select($scope.configs.paper.findViewByModel(obj));
        return obj;
      }

      function addNotification(id, position, data, parent) {
        var config = $scope.notificationConfig;
        //config.prop.data.id=id;
        config.id = id;

        if (position) {
          config.position = position;
        }

        var obj = new joint.shapes.basic.Notification(config);
        //add props idNotification,selectedUsers,condition,externalUsers,flowUsers,nextUser,users
        if (data !== undefined && data !== null) {
          obj.prop('prop/data/idNotification', data.idNotification);
          obj.prop('prop/data/selectedUsers', data.selectedUsers);
          obj.prop('prop/data/condition', data.condition);
          obj.prop('prop/data/externalUsers', data.externalUsers);
          obj.prop('prop/data/flowUsers', data.flowUsers);
          obj.prop('prop/data/nextUser', data.nextUser);
          obj.prop('prop/data/users', data.users);
          obj.prop('prop/data/sendGoodResults', data.sendGoodResults);
          obj.prop('prop/data/sendBadResults', data.sendBadResults);
          obj.title = data.title;
        }

        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.notifications++;
        obj.attributes.parent = parent;
        $scope.$broadcast('elementadded', [obj]);
        $scope.select($scope.configs.paper.findViewByModel(obj));
        return obj;
      }

      function addLink(source, target, text, vertices, parentIsDecision) {
        source = source || $scope.getSelection();

        var auxTarget = null;
        if (target) {
          auxTarget = { id: target.id };
        } else {
          auxTarget = {
            x: source.prop('position').x + source.prop('size').width / 2,
            y:
              source.prop('position').y +
              source.prop('size').height +
              ($scope.configs.orientation === 'vertical' ? 40 : 70),
          };
        }

        var labels = null;

        if (source.prop('prop/data/type') === ETaskTypes.Decision) {
          labels = [
            {
              position: 0.5,
              attrs: {
                text: {
                  text:
                    text ||
                    'option ' +
                      ($scope.configs.graph.getConnectedLinks(source, {
                        outbound: true,
                      }).length +
                        1),
                  'font-size': 10,
                },
                rect: {
                  stroke: 'none',
                  'stroke-width': 0,
                },
              },
            },
          ];
        }

        var obj = new joint.dia.Link({
          interactive: false,
          source: { id: source.id },
          target: auxTarget,
          parentIsDecision: parentIsDecision,
          connector: { name: 'normal' },
          prop: {
            data: {
              type: 'link',
            },
          },
          attrs: {
            //remove todas as opções de mover o link, ver como fazer isso apenas no source
            // '.marker-arrowheads': {
            //     display: 'none'
            // },
            '.connection': {
              stroke: '#58B',
              'stroke-width': 2,
            },
            '.marker-target': {
              stroke: '#58B',
              fill: '#58B',
              d: 'M 10 0 L 0 5 L 10 10 z',
            },
          },
          labels: labels,
          vertices: vertices,
        });

        obj.on('change:target', function (link) {
          var target = link.prop('target/id');
          if (target) {
            $scope.select(
              $scope.configs.paper.findViewByModel(
                $scope.configs.graph.getCell(target)
              )
            );
          }
        });
        $scope.configs.graph.addCells([obj]);
        $scope.unselect();
        return obj;
      }

      function addStart(id, text, position, parent) {
        var config = $scope.startConfig;
        //config.prop.data.id=id;
        config.id = id;
        config.attrs.text.text = text;
        if (position) {
          config.position = position;
        } else {
          config.position.x =
            $scope.configs.swimlaneSize.width / 2 -
            $scope.startConfig.size.width / 2;
        }
        var obj = new joint.shapes.basic.Circle(config);
        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.starts++;
        obj.attributes.parent = parent;
        $scope.$broadcast('elementadded', [obj]);
        return obj;
      }

      function addEnd(id, text, position, parent) {
        var config = $scope.endConfig;
        //config.prop.data.id=id;
        config.id = id;
        config.attrs.text.text = text;

        if (position) {
          config.position = position;
        } else {
          config.position = {
            x:
              $scope.configs.swimlaneSize.width / 2 -
              $scope.endConfig.size.width / 2,
            y:
              $scope.configs.swimlaneSize.height / 2 -
              $scope.endConfig.size.height / 2,
          };
        }

        var obj = new joint.shapes.basic.Circle(config);

        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.ends++;
        obj.attributes.parent = parent;
        $scope.$broadcast('elementadded', [obj]);

        return obj;
      }

      function addReleaseDocument(id, text, position, parent) {
        var config = $scope.releaseConfig;
        //config.prop.data.id=id;
        config.id = id;

        if (position) {
          config.position = position;
        } else {
          config.position.x =
            $scope.configs.swimlaneSize.width / 2 -
            $scope.taskConfig.size.width / 2;
        }

        var obj = new joint.shapes.basic.ReleaseDocument(config);

        if ($scope.configs.orientation === 'horizontal') {
          obj.rotate(90);
        }

        $scope.configs.graph.addCells([obj]);
        $scope.configs.elementsCount.releases++;

        obj.attributes.parent = parent;
        $scope.$broadcast('elementadded', [obj]);

        $scope.select($scope.configs.paper.findViewByModel(obj));

        return obj;
      }

      function remove(element) {
        switch (element.prop('prop/data/type')) {
          case 'swimlane':
            $scope.configs.elementsCount.swimlanes--;
            break;
          case ETaskTypes.Task:
            $scope.configs.elementsCount.tasks--;
            break;
          case ETaskTypes.Decision:
            $scope.configs.elementsCount.decisions--;
            break;
          case ETaskTypes.Notification:
            $scope.configs.elementsCount.notifications--;
            break;
          case ETaskTypes.Start:
            $scope.configs.elementsCount.starts--;
            break;
          case ETaskTypes.End:
            $scope.configs.elementsCount.ends--;
            break;
          case ETaskTypes.ReleaseDocument:
            $scope.configs.elementsCount.releases--;
            break;
        }

        $scope.unselect();

        _.remove($scope.configs.data, function (item) {
          return item.id === element.id;
        });

        element.remove();
      }

      function loadGroups() {
        return flowService.getUsersAndGroups();
      }

      function getWorkflowData(element, id, flow) {
        if (!flow.Swimlanes) {
          return;
        }

        var el;
        var type = element.prop('prop/data/type');

        if (type === 'swimlane') {
          // Busca a swimlane
          el = flow.Swimlanes.find(function (s) {
            return s.JointId === id;
          });
          if (!el) {
            // eslint-disable-next-line no-console
            console.warn('Swimlane não encontrada para JointId:', id);
            return;
          }
          element.PersonDocumentAuthor = el.PersonDocumentAuthor;
        } else {
          // Busca a swimlane-pai
          var sw = flow.Swimlanes.find(function (s) {
            return s.JointId === element.attributes.parent;
          });

          if (!sw) {
            // eslint-disable-next-line no-console
            console.warn('Swimlane-pai não encontrada para elemento:', element.id);
            // fallback: try to find in any swimlane
            sw = flow.Swimlanes.find(s => s.Elements && s.Elements.some(e => e.JointId === id));
          }

          if (sw) {
            el = sw.Elements.find(function (s) {
              return s.JointId === id;
            });
          }

          if (!el) {
            // last fallback: search all elements in all swimlanes
            el = flow.Swimlanes.flatMap(s => s.Elements || []).find(e => e.JointId === id);
          }

          if (!el) {
            // eslint-disable-next-line no-console
            console.warn('Elemento não encontrado em nenhuma swimlane para JointId:', id);
            return;
          }
        }

        // Assign properties safely
        element.databaseId = el.Id;
        element.id = el.JointId;
        element.name = el.Name || '';
        element.description = el.Description || '';
        element.isDescriptionOptional = el.IsDescriptionOptional || false;

        var t = el.Type || 0;
        var taskType = $scope.taskTypes.find(function (item) {
          return item.id === t;
        });
        element.type = taskType || t;
        element.fields = el.fields || [];

        if (type === ETaskTypes.Notification || type === 'swimlane') {
          $scope.loadGroups().then(function (data) {
            if (el.Groups) {
              el.Groups.forEach(function (grp) {
                var g = data[0].find(function (group) {
                  return group.Id === grp.Id;
                });
                if (g) g.selected = true;
              });
            }
            if (el.Users) {
              el.Users.forEach(function (usr) {
                var u = data[1].find(function (user) {
                  return user.Id === usr.Id;
                });
                if (u) u.selected = true;
              });
            }
            element.groups = data[0];
            element.users = data[1];
          });
        } else if (type === ETaskTypes.End) {
          var endAction = el.EndAction || 0;
          element.endAction = $scope.endActions.find(function (item) {
            return item.id === endAction;
          });
        }

        element.title = el.Title || '';
        element.notificationMessage = el.Message || '';
        element.duration = el.Duration || 0;
      }

      function loadDocumentTypes() {
        $scope.loadingDocumentTypes = true;
        $scope.docTypeLoadError = false;
        documentTypeCrudService.list().then(
          function (data) {
            if ($scope.flowData.savedDocumentTypes) {
              for (
                var cont = 0, len = $scope.flowData.savedDocumentTypes.length;
                cont < len;
                cont++
              ) {
                var dt = data.filter(function (docType) {
                  return (
                    docType.id === $scope.flowData.savedDocumentTypes[cont]
                  );
                })[0];
                if (dt) {
                  dt.selected = true;
                }
              }
            }
            $scope.flowData.documentTypes = data;
            $scope.loadingDocumentTypes = false;
          },
          function () {
            $scope.loadingDocumentTypes = false;
            $scope.docTypeLoadError = true;
          }
        );
      }

      function load(flow) {
        if (!flow) {
          swal.fire({
            title: 'Fluxo não encontrado',
            text: 'Não foi possível encontrar o fluxo, pode ser que ele pertença a outra empresa',
            preConfirm: function () {
              return new Promise(function (resolve) {
                $state.go('flows.base.models');
                resolve();
              });
            },
          });
          return;
        }

        var data =
          typeof flow.GraphElements === 'string'
            ? JSON.parse(flow.GraphElements)
            : flow.GraphElements;

        if (flow.Id || $scope.action === 'clone') {
          $scope.flowData.databaseId = flow.Id;
          $scope.flowData.flowName = flow.Name;
          $scope.flowData.flowDescription = flow.Description;
          var triggerType = flow.TriggerType ? flow.TriggerType : 0;
          $scope.flowData.triggerType = $scope.flowData.triggerTypes.filter(
            function (item) {
              return item.id === triggerType;
            }
          )[0];
          $scope.flowData.rowGuid = flow.RowGuid;
          $scope.flowData.savedDocumentTypes = flow.DocumentTypes;
          $scope.flowData.selectedFolders = flow.Folders;
        }

        $scope.loadDocumentTypes();

        var fnGetElements = function (graph, type) {
          return _.filter(graph.cells, function (item) {
            return item.type === type || item.prop.data.type === type;
          });
        };

        var lstIDs = {};

        var lstSwimlanes = _.sortBy(
          fnGetElements(data.graph, 'swimlane'),
          function (item) {
            return item.position.x;
          }
        );

        var lstTasks = fnGetElements(data.graph, ETaskTypes.Task);
        var lstDecisions = fnGetElements(data.graph, ETaskTypes.Decision);
        var lstNotifications = fnGetElements(
          data.graph,
          ETaskTypes.Notification
        );
        var lstStarts = fnGetElements(data.graph, ETaskTypes.Start);
        var lstEnds = fnGetElements(data.graph, ETaskTypes.End);
        var lstReleases = fnGetElements(data.graph, ETaskTypes.ReleaseDocument);
        var lstLinks = fnGetElements(data.graph, 'link');

        for (var x = 0; x < lstSwimlanes.length; x++) {
          var obj = $scope.addSwimlane(
            lstSwimlanes[x].id,
            lstSwimlanes[x].attrs.text.text
          );
          $scope.getWorkflowData(obj, lstSwimlanes[x].id, flow);
          obj.prop('prop/data/saved', data.saved);
          lstIDs[lstSwimlanes[x].id] = obj;

          //faz o ajuste da posição das swimlanes
          $scope.loadPositions();
        }

        for (var xTask = 0; xTask < lstTasks.length; xTask++) {
          var objTask = $scope.addTask(
            lstTasks[xTask].id,
            lstTasks[xTask].attrs.text.text,
            lstTasks[xTask].position,
            lstTasks[xTask].parent
          );
          $scope.getWorkflowData(objTask, lstTasks[xTask].id, flow);
          objTask.prop('prop/data/saved', data.saved);
          lstIDs[lstTasks[xTask].id] = objTask;
        }

        for (var xDecision = 0; xDecision < lstDecisions.length; xDecision++) {
          var objDecision = $scope.addDecision(
            lstDecisions[xDecision].id,
            lstDecisions[xDecision].attrs.text.text,
            lstDecisions[xDecision].position,
            lstDecisions[xDecision].parent
          );
          $scope.getWorkflowData(objDecision, lstDecisions[xDecision].id, flow);
          objDecision.prop('prop/data/saved', data.saved);
          lstIDs[lstDecisions[xDecision].id] = objDecision;
        }
        for (var xNot = 0; xNot < lstNotifications.length; xNot++) {
          var objNot = $scope.addNotification(
            lstNotifications[xNot].id,
            lstNotifications[xNot].position,
            lstNotifications[xNot].prop.data,
            lstNotifications[xNot].parent
          );
          $scope.getWorkflowData(objNot, lstNotifications[xNot].id, flow);
          objNot.prop('prop/data/saved', data.saved);
          lstIDs[lstNotifications[xNot].id] = objNot;
        }
        for (var xStart = 0; xStart < lstStarts.length; xStart++) {
          var objStart = $scope.addStart(
            lstStarts[xStart].id,
            lstStarts[xStart].attrs.text.text,
            lstStarts[xStart].position,
            lstStarts[xStart].parent
          );
          $scope.getWorkflowData(objStart, lstStarts[xStart].id, flow);
          objStart.prop('prop/data/saved', data.saved);
          lstIDs[lstStarts[xStart].id] = objStart;
        }
        for (var xEnd = 0; xEnd < lstEnds.length; xEnd++) {
          var objEnd = $scope.addEnd(
            lstEnds[xEnd].id,
            lstEnds[xEnd].attrs.text.text,
            lstEnds[xEnd].position,
            lstEnds[xEnd].parent
          );
          objEnd.endAction = $scope.endActions[0];
          $scope.getWorkflowData(objEnd, lstEnds[xEnd].id, flow);
          objEnd.prop('prop/data/saved', data.saved);
          lstIDs[lstEnds[xEnd].id] = objEnd;
        }
        for (var xRelease = 0; xRelease < lstReleases.length; xRelease++) {
          var objRelease = $scope.addReleaseDocument(
            lstReleases[xRelease].id,
            '',
            lstReleases[xRelease].position,
            lstReleases[xRelease].parent
          );
          $scope.getWorkflowData(objRelease, lstReleases[xRelease].id, flow);
          objRelease.prop('prop/data/saved', data.saved);
          lstIDs[lstReleases[xRelease].id] = objRelease;
        }
        for (var xLink = 0; xLink < lstLinks.length; xLink++) {
          var label = null;
          if (lstLinks[xLink].labels) {
            label = lstLinks[xLink].labels[0].attrs.text.text;
          }

          var source = lstIDs[lstLinks[xLink].source.id];
          var target = lstIDs[lstLinks[xLink].target.id];
          var objLink = $scope.addLink(
            source,
            target,
            label,
            lstLinks[xLink].vertices,
            source.attributes.prop.data.type === ETaskTypes.Decision
          );
          var lnk = null;
          if (flow.Links) {
            lnk = flow.Links.filter(function (l) {
              return (
                l.IdElement === lstLinks[xLink].source.id &&
                l.IdNextElement === lstLinks[xLink].target.id
              );
            })[0];
          }
          if (lnk) {
            objLink.databaseId = lnk.Id;
            if (lnk.CssColor) {
              objLink.color = $scope.linkColors.filter(function (c) {
                return c.name === lnk.CssColor;
              })[0];
            }
          }
          objLink.prop('prop/data/saved', data.saved);
          lstIDs[lstLinks[xLink].id] = objLink;
        }

        for (var i = 0; i < lstSwimlanes.length; i++) {
          var swimlane = lstSwimlanes[i];
          if (swimlane.embeds) {
            for (var y = 0; y < swimlane.embeds.length; y++) {
              if (lstIDs[swimlane.embeds[y]]) {
                var child = lstIDs[swimlane.embeds[y]];
                var parent = $scope.configs.graph.getCell(child.get('parent'));

                if (parent) {
                  parent.unembed(child);
                }

                lstIDs[swimlane.id].embed(child);
              }
            }
          }
        }

        if (data.orientation === 'horizontal') {
          $scope.switchOrientation();
        }

        if (data.data) {
          $scope.configs.data = data.data;
        }
        $scope.loadingWorkflow = false;
      }

      function getElements(type, graph) {
        graph = graph || $scope.configs.graph;

        var lst = graph.getElements();

        if (!type) {
          return lst;
        }

        type = type instanceof Array ? type : [type];

        var result = [];

        for (var x = 0; x < lst.length; x++) {
          if (type.indexOf(lst[x].prop('prop/data/type')) !== -1) {
            result[result.length] = lst[x];
          }
        }

        return result;
      }

      function savePositions() {
        var lstSL = _.sortBy($scope.getElements('swimlane'), function (item) {
          return item.get('position').x;
        });

        for (var x = 0; x < lstSL.length; x++) {
          lstSL[x].prop('prop/data/index', x);

          var lstChildren = _.filter(
            lstSL[x].getEmbeddedCells(),
            function (item) {
              return item.prop('prop/data/type') !== 'link';
            }
          );

          for (var y = 0; y < lstChildren.length; y++) {
            var path = 'prop/data/children/' + lstChildren[y].id + '/position';
            var position = lstChildren[y].position({ parentRelative: true });

            if (!position) {
              // eslint-disable-next-line no-console
              console.warn('Position is undefined for:', lstChildren[y]);
              continue;
            }

            lstSL[x].prop(path, position);
          }
        }
      }

      function loadPositions() {
        const swimlanes = $scope.getElements('swimlane');

        const lstSL = _.sortBy(swimlanes, function (item) {
          const pos = item?.get?.('position');
          if (!pos || typeof pos.x !== 'number') {
            // eslint-disable-next-line no-console
            console.warn('Swimlane inválida em loadPositions:', item);
            return 0;
          }
          return pos.x;
        });

        for (let x = 0; x < lstSL.length; x++) {
          lstSL[x].set('position', {
            x: $scope.configs.swimlaneSize.width * x + 1,
            y: 1,
          });

          const lstChildren = _.filter(lstSL[x].getEmbeddedCells(), function (child) {
            return child?.prop?.('prop/data/type') !== 'link';
          });

          for (let y = 0; y < lstChildren.length; y++) {
            const path = 'prop/data/children/' + lstChildren[y].id + '/position';
            const pos = lstSL[x].prop(path);

            if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
              lstChildren[y].position(pos.x, pos.y, { parentRelative: true });
            } else {
              // eslint-disable-next-line no-console
              console.warn(`Posição inválida para child ${lstChildren[y].id}:`, pos);
            }
          }
        }
      }

      function switchOrientation() {
        $scope.configs.orientation =
          $scope.configs.orientation === 'vertical' ? 'horizontal' : 'vertical';

        var svg = $scope.configs.paperElement.find('svg');
        var isVertical = $scope.configs.orientation === 'vertical';

        var swimlaneWidth =
          ($scope.configs.swimlaneSize.width + 1) *
            $scope.configs.elementsCount.swimlanes +
          1;
        var swimlaneHeight = $scope.configs.swimlaneSize.height + 2;

        var width = isVertical ? swimlaneWidth : swimlaneHeight;
        var height = isVertical ? swimlaneHeight : swimlaneWidth;

        svg.attr('width', width * 1.5);
        svg.attr('height', height);

        $scope.configs.paper.setDimensions(width * 1.5, height);

        var resizeVal =
          ((width / 2) * $scope.configs.elementsCount.swimlanes + 1) / 2 -
          9 * $scope.configs.elementsCount.swimlanes;

        $scope.configs.paper.rotate(
          isVertical ? 90 : -90,
          resizeVal,
          resizeVal
        );

        var lst = $scope.configs.graph.getElements();

        for (var x = 0; x < lst.length; x++) {
          if (lst[x].prop('prop/data/type') !== 'swimlane') {
            lst[x].rotate(isVertical ? -90 : 90);
          }
        }
      };

      function validateConnection(cellViewS, magnetS, cellViewT) {
        var isValid =
          (!cellViewS ||
            cellViewS.model.prop('prop/data/type') !== 'swimlane') &&
          (!cellViewT ||
            cellViewT.model.prop('prop/data/type') !== 'swimlane') &&
          (!cellViewS ||
            !cellViewT ||
            cellViewS.model.id !== cellViewT.model.id);

        return isValid;
      }

      function validateEmbedding(childView, parentView) {
        if (childView.model.prop('prop/data/type') === 'swimlane') {
          return false;
        }

        var lst = $scope.getElements('swimlane');
        for (var x = 0; x < lst.length; x++) {
          var p = $scope.getParentElement(parentView);
          if (p && lst[x] !== p.model) {
            lst[x].toBack();
          }
        }

        return true;
      }

      function getParentElement(cellView) {
        if (cellView.model.prop('prop/data/type') === 'swimlane') {
          return cellView;
        }

        var parentModel = cellView.model.get('parent');

        if (!parentModel) {
          return null;
        }

        var parentView = $scope.configs.paper.findViewByModel(parentModel);

        return $scope.getParentElement(parentView);
      }

      function defineNewElements() {
        joint.shapes.basic.Decision = joint.shapes.basic.Generic.extend({
          markup:
            '<g class="rotatable"><g class="scalable"><polygon class="outer"/><polygon class="inner"/></g><text/></g>',
          defaults: joint.util.deepSupplement(
            {
              type: 'basic.Decision',
              size: { width: 120, height: 80 },
              position: { x: 0, y: 0 },
              angle: 0,
              attrs: {
                '.inner': {
                  display: 'auto',
                  fill: '#F09060',
                  stroke: '#FFF',
                  'stroke-width': 2,
                  points: '40,5 75,40 40,75 5,40',
                },
                text: {
                  text: '?',
                  'font-family': 'Arial',
                  'font-size': 10,
                  ref: '.',
                  'ref-x': 0.5,
                  'ref-y': 0.5,
                  'x-alignment': 'middle',
                  'y-alignment': 'middle',
                  'font-weight': 'lighter',
                },
                '.outer': {
                  fill: '#F09060',
                  points: '40,0 80,40 40,80 0,40',
                },
              },
            },
            joint.shapes.basic.Generic.prototype.defaults
          ),
        });

        joint.shapes.basic.Task = joint.shapes.basic.Generic.extend({
          markup:
            '<g class="rotatable"><g class="scalable"><rect/></g><circle/><text class="removeTask"/><text/></g>',
          defaults: joint.util.deepSupplement(
            {
              type: 'basic.Task',
              size: { width: 120, height: 50 },
              attrs: {
                rect: { fill: '#fcefec', width: '120', height: '50' },
                text: {
                  text: '?',
                  'font-family': 'Arial',
                  'font-size': 10,
                  ref: 'rect',
                  'ref-x': '0.5',
                  'ref-y': '0.5',
                  'x-alignment': 'middle',
                  'y-alignment': 'middle',
                  'font-weight': 'lighter',
                },
                circle: {
                  fill: '#F09060',
                  r: 10,
                  ref: 'rect',
                  'ref-x': '100%',
                  'ref-y': '0',
                },
                '.removeTask': {
                  text: String.fromCharCode(parseInt('f00d', 16)),
                  'font-size': 12,
                  'font-family': 'FontAwesome',
                  ref: 'circle',
                  'ref-x': '0.5',
                  'ref-y': '0.5',
                  'x-alignment': 'middle',
                  'y-alignment': 'middle',
                },
              },
            },
            joint.shapes.basic.Generic.prototype.defaults
          ),
        });

        joint.shapes.basic.MySwimlane = joint.shapes.basic.Generic.extend({
          markup:
            '<g class="rotatable"><g class="scalable"><rect class="body"/><rect class="title"/></g><text/></g>',
          defaults: joint.util.deepSupplement(
            {
              type: 'basic.MySwimlane',
              prop: { data: { type: 'swimlane' } },
              size: {
                width: $scope.configs.swimlaneSize.width,
                height: $scope.configs.swimlaneSize.height,
              },
              position: { x: 1, y: 1 },
              attrs: {
                //".title":{fill:"#F9F9F9",stroke:'#DDD','stroke-width':0,x:1,y:1,width:198,height:28,style:{'user-drag':'none'}},
                text: {
                  text: $filter('translate')('SWIMLANE'),
                  'font-family': 'Arial',
                  fill: '#999',
                  'font-size': 12,
                  ref: '.',
                  'ref-x': 0.5,
                  'ref-y': 10,
                  'x-alignment': 'middle',
                  'y-alignment': 'top',
                  'font-weight': 'lighter',
                },
                '.body': {
                  fill: '#FFF',
                  stroke: '#DDD',
                  'stroke-width': 2,
                  width: $scope.configs.swimlaneSize.width,
                  height: $scope.configs.swimlaneSize.height,
                  x: 0,
                  y: 0,
                  style: { 'pointer-events': 'none' },
                },
              },
            },
            joint.shapes.basic.Generic.prototype.defaults
          ),
        });
        joint.shapes.basic.Notification = joint.shapes.basic.Generic.extend({
          markup:
            '<g class="rotatable"><g class="scalable"><circle/></g><text class="notificationIcon"/><text/></g>',
          defaults: joint.util.deepSupplement(
            {
              type: 'basic.Notification',
              size: { width: 29, height: 29 },
              attrs: {
                circle: {
                  fill: '#69C',
                  stroke: '#47A',
                  'stroke-width': 2,
                  r: 29,
                  cx: 29,
                  cy: 29,
                },
                /*'text':{'font-size':14,text:'','ref-x':.5,'ref-y':.5,ref:'circle','y-alignment':'middle','x-alignment':'middle',fill:'black'},*/
                text: {
                  fill: '#fff',
                  'font-size': 10,
                  'font-weight': 'lighter',
                },
                '.notificationIcon': {
                  text: String.fromCharCode(parseInt('f0e0', 16)),
                  'font-size': 18,
                  'font-family': 'FontAwesome',
                  ref: 'circle',
                  'ref-x': '0.53',
                  'ref-y': '0.52',
                  'x-alignment': 'middle',
                  'y-alignment': 'middle',
                  width: 22,
                  height: 22,
                },
              },
            },
            joint.shapes.basic.Generic.prototype.defaults
          ),
        });

        joint.shapes.basic.ReleaseDocument = joint.shapes.basic.Generic.extend({
          markup:
            '<g class="rotatable"><g class="scalable"><circle/></g><text class="releaseIcon"/><text/></g>',
          defaults: joint.util.deepSupplement(
            {
              type: 'basic.ReleaseDocument',
              size: { width: 29, height: 29 },
              attrs: {
                circle: {
                  fill: '#4CAF50',
                  stroke: '#009688',
                  'stroke-width': 2,
                  r: 29,
                  cx: 29,
                  cy: 29,
                },
                /*'text':{'font-size':14,text:'','ref-x':.5,'ref-y':.5,ref:'circle','y-alignment':'middle','x-alignment':'middle',fill:'black'},*/
                text: {
                  fill: '#FFF',
                  'font-size': 10,
                  'font-weight': 'lighter',
                },
                '.releaseIcon': {
                  text: String.fromCharCode(parseInt('f13e', 16)),
                  'font-size': 18,
                  'font-family': 'FontAwesome',
                  ref: 'circle',
                  'ref-x': '0.52',
                  'ref-y': '0.56',
                  'x-alignment': 'middle',
                  'y-alignment': 'middle',
                },
              },
            },
            joint.shapes.basic.Generic.prototype.defaults
          ),
        });
      }

      function getConfig(element) {
        if (!element) {
          element = $scope.getSelection();
        }

        var id = typeof element === 'string' ? element : element.id;

        var conf = _.find($scope.configs.data, function (item) {
          return item.id === id;
        });

        if (!conf) {
          conf = { id: id };
          $scope.configs.data[$scope.configs.data.length] = conf;
        }
        return conf;
      }

      function setConfig(element, property, value) {
        if (!element) {
          element = $scope.getSelection();
        }

        var id = typeof element === 'string' ? element : element.id;

        var pType = typeof property;
        if (pType === 'string') {
          var conf = _.find($scope.configs.data, function (item) {
            return item.id === id;
          });
          if (!conf) {
            conf = { id: id };
            $scope.configs.data[$scope.configs.data.length] = conf;
          }
          conf[property] = value;
        }

        if (pType === 'object') {
          var index = _.findIndex($scope.configs.data, function (item) {
            return item.id === id;
          });

          if (index !== -1) {
            $scope.configs.data.slice(index, 1);
          }

          var i = index !== -1 ? index : $scope.configs.data.length;

          $scope.configs.data[i] = property;
        }
      }

      function isValid() {
        return $scope.getErrorCode() === '';
      }

      function getErrorCode() {
        // exactly 1 start; at least 1 end; at least 1 swimlane
        if (
          $scope.getElements(ETaskTypes.Start).length !== 1 ||
          $scope.getElements(ETaskTypes.End).length < 1 ||
          $scope.getElements('swimlane').length < 1
        ) {
          return 'WORKFLOW MUST HAVE ONE START; AT LEAST ONE END; AT LEAST ONE SWIMLANE';
        }
        // no link with the same source/target
        if (
          _.some($scope.getElements(), function (el) {
            return _.some(
              $scope.configs.graph.getConnectedLinks(el),
              function (ln) {
                return ln.prop('source/id') === ln.prop('target/id');
              }
            );
          })
        ) {
          return 'NO LINK WITH THE SAME SOURCE/TARGET';
        }
        // start has exactly 1 outbound link
        if (
          _.some($scope.getElements(ETaskTypes.Start), function (el) {
            return $scope.configs.graph.getConnectedLinks(el).length !== 1;
          }) ||
          _.some($scope.getElements(ETaskTypes.Start), function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { inbound: true })
                .length > 0
            );
          })
        ) {
          return 'START HAS EXACTLY ONE OUTBOUND LINK';
        }
        // ends have at least 1 inbound link
        if (
          _.some($scope.getElements(ETaskTypes.End), function (el) {
            return $scope.configs.graph.getConnectedLinks(el).length < 1;
          }) ||
          _.some($scope.getElements(ETaskTypes.End), function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { outbound: true })
                .length > 0
            );
          })
        ) {
          return 'ENDS HAVE AS LEAST ONE INBOUND LINK';
        }
        var elIn = _.find(
          $scope.getElements([ETaskTypes.Task, ETaskTypes.Notification]),
          function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { inbound: true })
                .length < 1
            );
          }
        );
        if (elIn) {
          var name = elIn.name || elIn.attr('text/text');
          return String.format(
            $filter('translate')(
              'TASK/NOTIFICATION HAVE AT LEAST ONE INBOUND LINK'
            ),
            [elIn.title || name]
          );
        }
        var elOut = _.find(
          $scope.getElements([ETaskTypes.Task, ETaskTypes.Notification]),
          function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { outbound: true })
                .length !== 1
            );
          }
        );
        if (elOut) {
          var elName = elOut.name || elOut.attr('text/text');
          return String.format(
            $filter('translate')(
              'TASK/NOTIFICATION HAVE ONLY ONE OUTBOUND LINK'
            ),
            [elOut.title || elName]
          );
        }
        // decisions have at least 1 inbound and up to 3 outbound links
        if (
          _.some($scope.getElements(ETaskTypes.Decision), function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { inbound: true })
                .length < 1
            );
          }) ||
          _.some($scope.getElements(ETaskTypes.Decision), function (el) {
            return (
              [1, 2, 3, 4, 5, 6, 7].indexOf(
                $scope.configs.graph.getConnectedLinks(el, { outbound: true })
                  .length
              ) === -1
            );
          })
        ) {
          return 'DECISION HAVE AT LEAST ONE INBOUND AND UP TO 7 OUTBOUND LINKS';
        }
        // release document have at least 1 inbound and 1 outbound link
        if (
          _.some($scope.getElements(ETaskTypes.ReleaseDocument), function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { inbound: true })
                .length < 1
            );
          }) ||
          _.some($scope.getElements(ETaskTypes.ReleaseDocument), function (el) {
            return (
              $scope.configs.graph.getConnectedLinks(el, { outbound: true })
                .length !== 1
            );
          })
        ) {
          return 'RELEASE DOCUMENT HAVE AT LEAST ONE INBOUND AND 1 OUTBOUND LINK';
        }
        // all links are connected
        if (
          _.some($scope.configs.graph.getLinks(), function (ln) {
            return !ln.prop('source/id') || !ln.prop('target/id');
          })
        ) {
          return 'ALL LINKS ARE CONNECTED';
        }
        // name is required to some elements
        // if (_.some($scope.getElements(['swimlane', ETaskTypes.Task, ETaskTypes.Decision, ETaskTypes.End]), function (el) {return !el.attr('text/text');})) {
        //     return 8;
        // }
        // element is not in a swimlane
        if (
          _.some(
            $scope.getElements([
              ETaskTypes.Task,
              ETaskTypes.Decision,
              ETaskTypes.Notification,
              ETaskTypes.Start,
              ETaskTypes.End,
            ]),
            function (el) {
              var parent = $scope.configs.graph.getCell(el.get('parent'));
              return !parent || parent.prop('prop/data/type') !== 'swimlane';
            }
          )
        ) {
          return 'ELEMENT IS NOT IN A SWIMLANE';
        }
        return '';
      }

      function getErrorMessage(code) {
        switch (code) {
          //deve ter apenas 1 inicio, ao menos 1 fim e uma raia
          case 1:
            return 'WORKFLOW MUST HAVE ONE START; AT LEAST ONE END; AT LEAST ONE SWIMLANE';
          //o link está apontando para o mesmo elemento
          case 2:
            return 'NO LINK WITH THE SAME SOURCE/TARGET';
          //deve ter apenas 1 saida do inicio
          case 3:
            return 'START HAS EXACTLY ONE OUTBOUND LINK';
          //deve ter ao menos 1 entrada no fim
          case 4:
            return 'ENDS HAVE AS LEAST ONE INBOUND LINK';
          //tarefas e notificações devem ter ao menos 1 entrada e 1 saida
          case 5:
            return 'TASKS/NOTIFICATIONS HAVE AT LEAST ONE INBOUND AND ONLY ONE OUTBOUND LINK';
          //decisões devem ter ao menos 1 entrada e até 3 saidas
          case 6:
            return 'DECISION HAVE AT LEAST ONE INBOUND AND UP TO 3 OUTBOUND LINKS';
          //todos os links devem estar conectados
          case 7:
            return 'ALL LINKS ARE CONNECTED';
          //nome é obrigatorio para alguns elementos
          case 8:
            return 'NAME IS REQUIRED TO SOME ELEMENTS';
          //elemento não está na raia
          case 9:
            return 'ELEMENT IS NOT IN A SWIMLANE';
        }
        return '';
      }

      function setEvents() {
        var paper = $scope.configs.paper;

        var elements = [
          ETaskTypes.Task,
          ETaskTypes.Decision,
          ETaskTypes.Notification,
          ETaskTypes.Start,
          ETaskTypes.End,
        ];

        paper.off('cell:pointerclick blank:pointerclick cell:pointerdown cell:pointerup');
        paper.off('cell:highlight cell:unhighlight');

        paper.on('cell:pointerclick', function (cellView) {
          var model = cellView.model;
          // eslint-disable-next-line no-unused-vars
          var type = model.prop('prop/data/type');

          if (!model.prop('prop/data/highlight')) {
            $scope.select(cellView);
          }
        });

        // eslint-disable-next-line no-unused-vars
        paper.on('blank:pointerclick', function (evt, x, y) {
          $scope.unselect();
        });

        // eslint-disable-next-line no-unused-vars
        paper.on('cell:pointerdown', function (cellView, evt) {
          var model = cellView.model;
          var type = model.prop('prop/data/type');

          if (type === 'swimlane') {
            $scope.savePositions();
          }
          if (elements.indexOf(type) !== -1) {
            var pos = model.position();
            model.prop('prop/data/position', pos);
            model.prop('prop/data/parent', model.get('parent'));
          }
        });

        // eslint-disable-next-line no-unused-vars
        paper.on('cell:pointerup', function (cellView, evt, x, y) {
          var model = cellView.model;
          var type = model.prop('prop/data/type');

          if (type !== 'link') {
            $scope.select(cellView);
          }
          var parentID = model.get('parent');

          if (elements.indexOf(type) !== -1) {
            var fnContainsPoint = function (box, point) {
              return (
                point.x >= box.x &&
                point.x <= box.width &&
                point.y >= box.y &&
                point.y <= box.height
              );
            };

            var pBox = $scope.configs.paper.getContentBBox();
            var cBox = cellView.getBBox();
            var isInArea =
              fnContainsPoint(pBox, cBox.origin()) &&
              fnContainsPoint(pBox, cBox.topRight()) &&
              fnContainsPoint(pBox, cBox.corner()) &&
              (pBox, cBox.bottomLeft());

            if (!parentID || !isInArea) {
              var oldPos = cellView.model.prop('prop/data/position');
              var newPos = cellView.model.position();

              if (oldPos.x !== newPos.x || oldPos.y !== newPos.y) {
                cellView.model.position(oldPos.x, oldPos.y);
                var previousParentId = cellView.model.get('parent');

                if (previousParentId) {
                  var previousParent = $scope.configs.graph.getCell(previousParentId);
                  if (previousParent) {
                    previousParent.unembed(cellView.model);
                  }
                }

                $scope.configs.graph
                  .getCell(cellView.model.prop('prop/data/parent'))
                  .embed(cellView.model);
              }
            }

            delete cellView.model.attributes.prop.data.position;
            delete cellView.model.attributes.prop.data.parent;

            return;
          }

          if (parentID) {
            // eslint-disable-next-line no-unused-vars
            var parentView = paper.findViewByModel(parentID);
          }

          if (type === 'swimlane') {
            $scope.loadPositions();
          }
        });

        $scope.$on('elementadded', function (e, args) {
          var model = args[0];
          var swimlanes = $scope.getElements('swimlane');
          if (model.attributes.parent) {
            var sw = swimlanes.find(s => s.id === model.attributes.parent) || swimlanes[0];
            sw.embed(model);
          } else {
            swimlanes[0].embed(model);
          }
        });

        paper.on({
          'cell:highlight': function (cellView, el, opt) {
            var type = cellView.model.prop('prop/data/type');
            if (type === 'link' && !cellView.model.attributes.parentIsDecision) return;
            if (opt.embedding) {
              var p = $scope.getParentElement(cellView);

              if (p) window.V(p.el).addClass('highlighted-parent');
            } else {
              window.V(el).addClass('highlighted');
            }
          },
          'cell:unhighlight': function (cellView, el, opt) {
            var type = cellView.model.prop('prop/data/type');
            if (type === 'link' && !cellView.model.attributes.parentIsDecision) return;
            if (opt.embedding) {
              var p = $scope.getParentElement(cellView);

              if (p) window.V(p.el).removeClass('highlighted-parent');
            } else {
              window.V(el).removeClass('highlighted');
            }
          },
        });

        $scope.linkNameChanged = function () {
          $scope.extraTab.selectedElement.name = $scope.extraTab.newName;
          $scope.extraTab.selectedElement.label(0, {
            attrs: { text: { text: $scope.extraTab.newName } },
          });
        };

        $scope.textChanged = function () {
          const element = $scope.extraTab.selectedElement;
          if (!element) return;

          const name = $scope.extraTab.newName;

          element.name = name;

          const view = $scope.configs.paper.findViewByModel(element);
          if (view) {
            const texts = view.el.querySelectorAll('text');

            let textEl = Array.from(texts).find(t => {
              return !t.classList.contains('removeTask');
            });

            if (!textEl) textEl = texts[0];

            if (textEl) {
              const tspan = textEl.querySelector('tspan');
              if (tspan) {
                tspan.textContent = name;
              } else {
                textEl.textContent = name;
              }
            }
          }

          const attrs = element.get('attrs');
          if (attrs && attrs.text) {
            attrs.text.text = name;
          }
        };

        $scope.extraTabPage = function () {
          if ($scope.extraTab && $scope.extraTab.selectedElement) {
            var t = $scope.extraTab.selectedElement.prop('prop/data/type');

            switch (t) {
              case ETaskTypes.Notification:
                t = 'notification';
                break;
              case ETaskTypes.Decision:
                t = 'decision';
                break;
              case ETaskTypes.Task:
                t = 'task';
                break;
              case ETaskTypes.End:
                t = 'end';
                break;
              default:
                break;
            }

            return '/views/modules/flow/tabs/' + t + '.html';
          } else {
            return '';
          }
        };

        $scope.isTask = function () {
          return $scope.verifyType(ETaskTypes.Task);
        };

        $scope.isNotification = function () {
          return $scope.verifyType(ETaskTypes.Notification);
        };

        $scope.isDecision = function () {
          return $scope.verifyType(ETaskTypes.Decision);
        };

        $scope.isSwimlane = function () {
          return $scope.verifyType('swimlane');
        };

        $scope.verifyType = function (t) {
          if ($scope.extraTab && $scope.extraTab.selectedElement) {
            var type = $scope.extraTab.selectedElement.prop('prop/data/type');
            return type === t;
          }
          return false;
        };

        $scope.selectedLoadGroups = function () {
          if (
            ($scope.isNotification() || $scope.isSwimlane()) &&
            ($scope.extraTab.selectedElement.groups || []).length === 0
          ) {
            $scope.loadingUsers = true;
            $scope.loadGroups().then(function (data) {
              $scope.extraTab.selectedElement.groups = data[0];
              $scope.extraTab.selectedElement.users = data[1];
              $scope.loadingUsers = false;
            });
          }
        };

        $scope.loadFolders = function () {
          if ($scope.flowData.folders || $scope.loadingFolders) {
            return;
          }
          $scope.folderLoadError = false;
          $scope.loadingFolders = true;
          folderService.loadBasic($scope.flowData.selectedFolders).then(
            function (folders) {
              $scope.flowData.folders = folders;
              $scope.loadingFolders = false;
            },
            function () {
              $scope.folderLoadError = true;
              $scope.loadingFolders = false;
            }
          );
        };

        $scope.updateSelectedFolders = function () {
          var selectedFolders = [];

          var recursiveSelected = function (folder) {
            if (Array.isArray(folder.children) && folder.children.length > 0) {
              for (
                var j = 0, length = folder.children.length;
                j < length;
                j++
              ) {
                var child = folder.children[j];
                if (child.selected()) {
                  selectedFolders.push(child);
                }
                recursiveSelected(child);
              }
            }
          };

          for (var i = 0, len = $scope.flowData.folders.length; i < len; i++) {
            var folder = $scope.flowData.folders[i];
            if (folder.selected()) {
              selectedFolders.push(folder);
            }

            recursiveSelected(folder);
          }
          $scope.flowData.selectedFolders = selectedFolders.map(
            function (item) {
              return item.id;
            }
          );
        };

        $scope.$on('crudCurrentItemEvent', function () {
          $scope.updateSelectedFolders();
        });

        $scope.selectAllDocumentTypes = function (value) {
          if (arguments.length > 0) {
            for (
              var cont = 0, len = $scope.flowData.documentTypes.length;
              cont < len;
              cont++
            ) {
              $scope.flowData.documentTypes[cont].selected = value;
            }
          } else {
            if (
              $scope.flowData.documentTypes === undefined ||
              $scope.flowData.documentTypes === null
            ) {
              return false;
            }

            return $scope.flowData.documentTypes.every(function (d) {
              return d.selected === true;
            });
          }
        };

        $scope.selectUsers = function () {
          if ($scope.modalOpen === true) {
            return;
          }

          $scope.modalOpen = true;

          var modal = uibModal.open({
            animation: true,
            templateUrl: '/views/modules/flow/partials/selectGroupUser.html',
            controller: 'flowSelectGroupsController',
            backdrop: 'static',
            keyboard: true,
            size: 'lg',
            resolve: {
              groups: function () {
                return $scope.extraTab.selectedElement.groups;
              },
              users: function () {
                return $scope.extraTab.selectedElement.users;
              },
            },
          });

          modal.result.then(
            function () {
              $scope.modalOpen = false;
            },
            function () {
              $scope.modalOpen = false;
            }
          );
        };

        $scope.$on('selectionchange', function (event, args) {
          $scope.$applyAsync(function () {
            var obj = args[0];

            var type = obj ? obj.prop('prop/data/type') : '';

            $scope.extraTab = {};
            var types = [];
            types.swimlane = 'SWIMLANE';
            types[ETaskTypes.Decision] = 'DECISION';
            types[ETaskTypes.Notification] = 'NOTIFICATION';
            types[ETaskTypes.Task] = 'TASK';
            types[ETaskTypes.End] = 'END';
            types['link'] = 'LINK';

            if (
              types[type] &&
              (type !== 'link' || obj.attributes.parentIsDecision)
            ) {
              $scope.extraTab.selectedElement = obj;
              $scope.extraTab.newName =
                type !== 'link'
                  ? $scope.extraTab.selectedElement.attr('text/text')
                  : $scope.extraTab.selectedElement.label(0).attrs.text.text;

              $scope.extraTab.title = function () {
                var taskType = $filter('translate')(types[type]);
                return (
                  taskType +
                  ' - ' +
                  ($scope.extraTab.newName ||
                    ($scope.extraTab.selectedElement.title
                      ? $scope.extraTab.selectedElement.title
                      : $filter('translate')('NO NAME')))
                );
              };
            }

            $scope.disableAddLink =
              obj === null ||
              type === ETaskTypes.End ||
              ($scope.configs.graph.getConnectedLinks(obj, { outbound: true })
                .length > 0 &&
                type !== ETaskTypes.Decision) ||
              type === 'swimlane' ||
              (type === ETaskTypes.Decision &&
                $scope.configs.graph.getConnectedLinks(obj, {
                  outbound: true,
                }).length > 2);

            $scope.disableRemoveElement = obj === undefined || obj === null;

            var lst = $scope.getElements('swimlane');

            for (var x = 0; x < lst.length; x++) {
              if (lst[x] !== obj) lst[x].toBack();
            }
          });
        });

        $scope.linkColors = [
          { name: 'danger', color: '#f44336' },
          { name: 'primary', color: '#2196f3' },
          { name: 'success', color: '#4caf50' },
          { name: 'warning', color: '#ff9800' },
          { name: 'deep', color: '#673AB7' },
          { name: 'teal', color: '#009688' },
          { name: 'brown', color: '#795548' },
        ];

        $scope.getHtml = function (text, actualColor) {
          var html =
            '<form name="linkOptions" id="linkOptions" style="width: 70%; margin-left: auto; margin-right: auto;" class="text-left" onsubmit="return false;">';
          html +=
            '<label for="swalLinkName" class="required">Nome do link</label><br />';
          if (text) {
            html +=
              '<input type="text" id="swalLinkName" name="swalLinkName" value="' +
              text +
              '"><br />';
          } else {
            html +=
              '<input type="text" id="swalLinkName" name="swalLinkName" placeholder="Nome da ligação"><br />';
          }
          html += '<div class="m-t-20 m-b-10">';
          html +=
            '<label for="linkColor" class="required">Selecione a cor da ligação</label><br />';
          for (var cont = 0; cont < $scope.linkColors.length; cont++) {
            var color = $scope.linkColors[cont];
            html +=
              '<div class="m-5 text-center" style="display: inline-block;">';
            html += '<div class="radio" style="display: inline">';
            html +=
              '<label style="align-items: center;" class="p-l-0"><div style="width: 30px; height: 30px;' +
              (color ? 'background-color: ' + color.color : '') +
              '"></div>';
            html +=
              '<input type="radio" name="linkColor" value="' +
              color.name +
              '" style="position: relative"' +
              (actualColor && actualColor.name === color.name
                ? ' checked '
                : '') +
              '>';
            html +=
              '<i class="input-helper" style="position: relative; top: 5px; right: 19px;"></i></label>';
            html += '</div></div>';
          }
          html += '</div></form>';
          return html;
        };

        $scope.configs.paper.on('cell:pointerdblclick', function (cellView) {
          if (!$scope.canEdit) {
            return;
          }
          var type = cellView.model.prop('prop/data/type');

          if (type === ETaskTypes.ReleaseDocument) {
            return;
          }

          if (type === 'link') {
            if (cellView.model.attributes.parentIsDecision) {
              var text = cellView.model.attributes.labels[0].attrs.text.text;
              var actualColor = $scope.extraTab.selectedElement.color;
              var html = $scope.getHtml(text, actualColor);
              swal
                .fire({
                  title: 'Edit link',
                  html: html,
                  preConfirm: function () {
                    return new Promise(function (resolve, reject) {
                      var name = window.linkOptions.elements.swalLinkName.value;
                      var color = window.linkOptions.elements.linkColor.value;
                      if (!name || !color) {
                        reject(
                          $filter('translate')(
                            'LINK NAME AND COLOR ARE REQUIRED'
                          )
                        );
                      } else {
                        resolve([name, color]);
                      }
                    });
                  },
                  showCancelButton: true,
                })
                .then(function (value) {
                  if (value) {
                    $scope.extraTab.selectedElement.name = value[0];
                    $scope.extraTab.selectedElement.color =
                      $scope.linkColors.filter(function (c) {
                        return c.name === value[1];
                      })[0];
                    cellView.model.label(0, {
                      attrs: { text: { text: value[0] } },
                    });
                  }
                });
            }
          } else {
            //if(['start','end'].indexOf(type)!=-1)
            var name = '';
            if ($scope.isNotification()) {
              name = cellView.model.title;
            } else {
              name = cellView.model.attr('text/text');
            }
            swal
              .fire({
                title: 'Edit',
                text: 'Element Name',
                input: 'text',
                inputValue: name,
                inputValidator: function (value) {
                  return new Promise(function (resolve, reject) {
                    if (value && value.length <= 25) {
                      resolve();
                    } else {
                      reject($filter('translate')('MAX SIZE MUST BE') + ' 25');
                    }
                  });
                },
                showCancelButton: true,
              })
              .then(function (value) {
                if (value) {
                  if ($scope.isNotification()) {
                    $scope.extraTab.selectedElement.title = value;
                  } else {
                    $scope.extraTab.selectedElement.name = value;
                    cellView.model.attr('text/text', value);
                  }
                  $scope.extraTab.newName = value;
                  $scope.$apply();
                }
              });
          }
        });
      }

      function canSave(workflow) {
        if (!workflow.name || !$scope.hasDocTypesAssigned()) {
          var msg = '';
          if (!workflow.name) {
            msg += $filter('translate')('WORKFLOW NAME REQUIRED');
          }
          if (!$scope.hasDocTypesAssigned()) {
            if (msg.length > 0) {
              msg += '<br />';
            }
            msg += $filter('translate')(
              'WORKFLOW DOCTYPES OR FOLDERS ASSING REQUIRED'
            );
          }
          if (msg.length === 0) {
            msg += $filter('translate')('ERROR ON WORKFLOW PROPERTIES');
          }
          swal.fire({
            title: $filter('translate')('ERROR'),
            html: msg,
            icon: 'info',
          });
          return false;
        }

        for (
          var cSwim = 0, lSwim = workflow.swimlanes.length;
          cSwim < lSwim;
          cSwim++
        ) {
          var swError = $scope.swimlaneValid(workflow.swimlanes[cSwim]);
          if (swError) {
            var swEr = '';
            if (typeof swError === 'string') {
              swEr = swError;
            } else {
              swEr = String.format($filter('translate')('ERROR AT SWIMLANE'), [
                $filter('translate')(swError.elementName),
                $filter('translate')(swError.error),
              ]);
            }
            swal.fire({
              title: $filter('translate')('ERROR'),
              text: swEr,
              icon: 'info',
            });
            return false;
          }
        }

        var decErrors = $scope.validateDecisionsTasks(workflow);
        if (decErrors) {
          var er = String.format(
            $filter('translate')('ELEMENT ERROR AT SWIMLANE'),
            [
              $filter('translate')(decErrors.elementName),
              decErrors.swimlaneName,
              $filter('translate')(decErrors.error),
            ]
          );
          swal.fire({
            title: $filter('translate')('ERROR'),
            text: er,
          });
          return false;
        }

        var anyWithoutColor = _.some(
          $scope.getElements(ETaskTypes.Decision),
          function (el) {
            var lnks = $scope.configs.graph.getConnectedLinks(el, {
              outbound: true,
            });
            return lnks.some(function (l) {
              var name = l.label() ? l.label(0).attrs.text.text : null;
              return (
                name === undefined ||
                name === null ||
                l.color === undefined ||
                l.color === null
              );
            });
          }
        );
        if (anyWithoutColor) {
          swal.fire({
            title: $filter('translate')('LINK ERROR'),
            text: $filter('translate')('ALL LINKS NEED NAME AND COLOR'),
          });
          return false;
        }

        var error = $scope.getErrorCode();
        if (error !== '') {
          swal.fire({
            title: $filter('translate')('ERROR'),
            text: $filter('translate')(error),
            icon: 'error',
          });
          return false;
        }

        return true;
      }

      function validateDecisionsTasks(workflow) {
        for (
          var cSwim = 0, lSwim = workflow.swimlanes.length;
          cSwim < lSwim;
          cSwim++
        ) {
          var tasks = workflow.swimlanes[cSwim].elements.filter(
            function (item) {
              return (
                [
                  ETaskTypes.Analysis,
                  ETaskTypes.Approve,
                  ETaskTypes.ApproveWithSignature,
                ].indexOf(item.type) > -1
              );
            }
          );
          if (tasks.length > 0) {
            for (var cTask = 0, lTask = tasks.length; cTask < lTask; cTask++) {
              var lnk = workflow.links.filter(function (l) {
                return l.idElement === tasks[cTask].jointId;
              })[0];
              if (lnk) {
                var dec = $scope.getElementById(lnk.idNextElement, workflow);
                if (!dec || dec.type !== ETaskTypes.Decision) {
                  return {
                    elementName: tasks[cTask].name,
                    error: 'ANALISYS AND APPROVES NEEDS A DECISION',
                    swimlaneName: workflow.swimlanes[cSwim].name,
                  };
                }
              } else {
                return {
                  elementName: tasks[cTask].name,
                  error: 'ANALISYS AND APPROVES NEEDS A DECISION',
                  swimlaneName: workflow.swimlanes[cSwim].name,
                };
              }
            }
          }
          var decisions = workflow.swimlanes[cSwim].elements.filter(
            function (item) {
              return item.type === ETaskTypes.Decision;
            }
          );
          if (decisions.length > 0) {
            for (
              var cDecision = 0, lDecision = decisions.length;
              cDecision < lDecision;
              cDecision++
            ) {
              var lnkDec = workflow.links.filter(function (l) {
                return l.idNextElement === decisions[cDecision].jointId;
              })[0];
              if (lnkDec) {
                var t = $scope.getElementById(lnkDec.idElement, workflow);
                if (
                  !t ||
                  [
                    ETaskTypes.Analysis,
                    ETaskTypes.Approve,
                    ETaskTypes.ApproveWithSignature,
                  ].indexOf(t.type) < 0
                ) {
                  return {
                    elementName: decisions[cDecision].name,
                    error: 'DECISION NEEDS A ANALISYS OR APPROVES',
                    swimlaneName: workflow.swimlanes[cSwim].name,
                  };
                }
              } else {
                return {
                  elementName: decisions[cDecision].name,
                  error: 'DECISION NEEDS A ANALISYS OR APPROVES',
                  swimlaneName: workflow.swimlanes[cSwim].name,
                };
              }
            }
          }
        }
        return '';
      }

      function getElementById(idElement, workflow) {
        for (
          var cSwim = 0, lSwim = workflow.swimlanes.length;
          cSwim < lSwim;
          cSwim++
        ) {
          var rev = workflow.swimlanes[cSwim].elements.filter(function (item) {
            return item.jointId === idElement;
          })[0];
          if (rev) {
            return rev;
          }
        }
        return null;
      }

      function swimlaneValid(swimlane) {
        if (!swimlane.name) {
          return 'SWIMLANE NAME REQUIRED';
        }

        var groups = swimlane.groups
          ? swimlane.groups.filter($scope.filter)
          : [];
        var users = swimlane.users ? swimlane.users.filter($scope.filter) : [];
        if (
          !swimlane.personDocumentAuthor &&
          !(users.length > 0 || groups.length > 0)
        ) {
          return {
            elementName: swimlane.name,
            error: 'REQUIRED TO SET DOCUMENT AUTHOR OR SELECT GROUP OR USER',
          };
        }

        var elError = $scope.elementsValid(swimlane);
        if (elError) {
          return String.format(
            $filter('translate')('ELEMENT ERROR AT SWIMLANE'),
            [
              $filter('translate')(elError.elementName),
              swimlane.name,
              $filter('translate')(elError.error),
            ]
          );
        }
      }

      function elementsValid(swimlane) {
        for (
          var cElem = 0, lElem = swimlane.elements.length;
          cElem < lElem;
          cElem++
        ) {
          var el = swimlane.elements[cElem];
          if (
            el.type === undefined ||
            el.type === null ||
            el.type === ETaskTypes.Task
          ) {
            return {
              elementName: el.name ? el.name : 'TASK',
              error: 'TASK TYPE REQUIRED',
            };
          }
          switch (el.type) {
            case ETaskTypes.Decision:
              var erDec = $scope.decisionValid(el);
              if (erDec) {
                return erDec;
              }
              break;
            case ETaskTypes.Notification:
              var erNot = $scope.notificationValid(el);
              if (erNot) {
                return erNot;
              }
              break;
            case ETaskTypes.Review:
            case ETaskTypes.Training:
            case ETaskTypes.Approve:
            case ETaskTypes.ApproveWithSignature:
            case ETaskTypes.Analysis:
            case ETaskTypes.Distribution:
              var erTask = $scope.taskValid(el);
              if (erTask) {
                return erTask;
              }
              break;
          }
        }
        return '';
      }

      function taskValid(element) {
        if (!element.name) {
          return { elementName: 'TASK', error: 'NAME REQUIRED' };
        }
        if (!element.description) {
          return { elementName: 'TASK', error: 'DESCRIPTION REQUIRED' };
        }
        if (
          element.duration !== undefined &&
          element.duration !== null &&
          element.duration <= 0
        ) {
          return {
            elementName: element.name,
            error: 'TASK DURATION MUST BE GREATER THAN ZERO',
          };
        }
        return '';
      }

      function decisionValid(element) {
        if (!element.name) {
          return { elementName: 'DECISION', error: 'NAME REQUIRED' };
        }
        return '';
      }

      function notificationValid(element) {
        if (!element.title) {
          return { elementName: 'NOTIFICATION', error: 'TITLE REQUIRED' };
        }
        var hasUsers = element.users.filter($scope.filter).length > 0;
        var hasGroups = element.groups.filter($scope.filter).length > 0;
        if (!hasUsers && !hasGroups) {
          return {
            elementName: element.title,
            error: 'NOTIFICATION USER OR GROUP ASSOCIATION REQUIRED',
          };
        }
        return '';
      }

      function validateFlow() {
        return $scope.flowData.name && $scope.hasDocTypesAssigned();
      }

      function getWorkflow() {
        var workflow = {};
        workflow.id = $scope.flowData.databaseId
          ? $scope.flowData.databaseId
          : 0;
        workflow.name = $scope.flowData.flowName;
        workflow.description = $scope.flowData.flowDescription;
        workflow.triggerType = $scope.flowData.triggerType.id;
        workflow.rowGuid = $scope.flowData.rowGuid;

        if ($scope.flowData.documentTypes) {
          var docTypes = $scope.flowData.documentTypes.filter(function (dt) {
            return dt.selected;
          });
          workflow.documentTypes = docTypes.map(function (item) {
            return item.id;
          });
        }
        workflow.folders = $scope.flowData.selectedFolders;

        //pega as swimlanes e os elementos que estão dentro dela
        workflow.swimlanes = _.map(
          $scope.getElements('swimlane'),
          function (item) {
            return {
              id: item.databaseId,
              jointId: item.id,
              name: item.attr('text/text'),
              description: item.description,
              personDocumentAuthor: item.PersonDocumentAuthor,
              groups:
                item.groups && !item.PersonDocumentAuthor
                  ? item.groups.filter($scope.filter)
                  : [],
              users:
                item.users && !item.PersonDocumentAuthor
                  ? item.users.filter($scope.filter)
                  : [],
              elements: _.map(
                _.filter($scope.getElements(), function (item2) {
                  return item2.get('parent') === item.id;
                }),
                function (item2) {
                  var conf = $scope.getConfig(item2.id);
                  return {
                    id: item2.databaseId,
                    jointId: item2.id,
                    //elementIndex: item2.prop('prop/data/elementIndex'),
                    name: getElementName(item2),
                    description: item2.description,
                    type:
                      item2.type &&
                      item2.type.id !== undefined &&
                      item2.type.id !== null
                        ? item2.type.id
                        : item2.prop('prop/data/type'),
                    fields: conf.Fields,
                    users: item2.users ? item2.users.filter($scope.filter) : [],
                    groups: item2.groups
                      ? item2.groups.filter($scope.filter)
                      : [],
                    title: item2.title,
                    message: item2.notificationMessage,
                    isDescriptionOptional: item2.isDescriptionOptional,
                    duration: item2.duration,
                    endAction: item2.endAction ? item2.endAction.id : null,
                  };
                }
              ),
            };
          }
        );
        //ver se tem nessecidade de salvar os links ou so fazer a ligação com o proximo passo
        workflow.links = _.map(
          _.filter($scope.configs.graph.getLinks(), function (item) {
            return item.prop('source/id') && item.prop('target/id');
          }),
          function (item) {
            return {
              idElement: item.prop('source/id'),
              idNextElement: item.prop('target/id'),
              name: item.label() ? item.label(0).attrs.text.text : null,
              id: item.databaseId,
              cssColor: item.color ? item.color.name : null,
            };
          }
        );
        return workflow;
      }

      function save() {
        var workflow = $scope.getWorkflow();
        var canSaveLog = !$scope.canSave(workflow);

        if (canSaveLog) {
          return;
        }

        //esse elemento é o desenho do fluxo que o jointjs entende
        //nesse caso não vai ter os grupos e algumas outras configurações
        //ver como fazer essa parte, talvez montar de acordo com o objeto, ou setar pelo id
        var graphElements = JSON.stringify({
          elementsCount: $scope.configs.elementsCount,
          orientation: $scope.configs.orientation,
          graph: $scope.configs.graph,
        });

        workflow.graphElements = graphElements;

        flowService.save(workflow).then(
          function () {
            $state.go('flows.base.models');
          },
          function (error) {
            $scope.modelState = error.modelState;
            if ($scope.modelState && $scope.formFlowProperties) {
              $scope.formFlowProperties.$setValidity(
                'formFlowProperties.$error.modelState',
                false
              );
            }

            swal.fire({
              title: error.title,
              html: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        );
      }

      function hasFlowPropertiesError() {
        return (
          $scope.modelState &&
          $scope.modelState['Name'] &&
          $scope.modelState['Name'].length > 0
        );
      }

      function validityModelState(keyToClear) {
        var isValid = true;
        var BreakException = {};
        try {
          if ($scope.modelState) {
            if ($scope.modelState[keyToClear]) {
              $scope.modelState[keyToClear] = [];
            }
            Object.keys($scope.modelState).forEach(function (key) {
              if (!key.startsWith('$') && $scope.modelState[key].length > 0) {
                isValid = false;
                throw BreakException;
              }
            });
          }
        } catch (e) {
          if (e !== BreakException) {
            throw e;
          }
        }
        if ($scope.newForm) {
          if (isValid) {
            $scope.newForm.$setValidity(
              'formFlowProperties.$error.modelState',
              true
            );
          } else {
            $scope.newForm.$setValidity(
              'formFlowProperties.$error.modelState',
              false
            );
          }
        }
      }

      function cancel() {
        var msg = $scope.flowData.databaseId
          ? 'CONFIRM CANCEL EDIT WORKFLOW'
          : 'CONFIRM CANCEL NEW WORKFLOW';
        swal
          .fire({
            title: $filter('translate')(msg),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showLoaderOnConfirm: true,
          })
          .then(function () {
            $scope.flowData = {};
            $state.go('flows.base.models');
          });
      }

      function showDescriptionOptionlCheckbox() {
        if (
          $scope.extraTab &&
          $scope.extraTab.selectedElement &&
          $scope.extraTab.selectedElement.type
        )
          return (
            $scope.extraTab.selectedElement.type.id !== ETaskTypes.Training &&
            $scope.extraTab.selectedElement.type.id !== ETaskTypes.Distribution
          );
      }

      function init(element) {
        $scope.taskTypes = [
          { id: ETaskTypes.Review, value: 'REVIEW' },
          { id: ETaskTypes.Training, value: 'TRAINING' },
          { id: ETaskTypes.Distribution, value: 'DISTRIBUTION' },
          { id: ETaskTypes.Analysis, value: 'ANALYSIS' },
          { id: ETaskTypes.Approve, value: 'APPROVE' },
        ];

        if (PermPermissionStore.hasPermissionDefinition('DIGITAL_SIGNATURE')) {
          $scope.taskTypes.push({
            id: ETaskTypes.ApproveWithSignature,
            value: 'APPROVE WITH SIGNATURE',
          });
        }

        $scope.configs.paperElement = element;
        $scope.defineNewElements();

        $scope.configs.graph = new joint.dia.Graph();

        $scope.configs.paper = new joint.dia.Paper({
          el: element,
          interactive: $scope.canEdit,
          width: $scope.configs.swimlaneSize.width * 2 + 4,
          height: $scope.configs.swimlaneSize.height + 4,
          gridSize: 1,
          model: $scope.configs.graph,
          embeddingMode: true,
          validateEmbedding: $scope.validateEmbedding,
          validateConnection: $scope.validateConnection,
          defaultLink: new joint.dia.Link({
            interactive: false,
            connector: { name: 'normal' },
            attrs: {
              '.connection': {
                stroke: '#58B',
                'stroke-width': 2,
              },
              '.marker-target': {
                stroke: '#58B',
                fill: '#58B',
                d: 'M 10 0 L 0 5 L 10 10 z',
              },
            },
          }),
        });

        //$scope.paperElement.data('flow', $scope.configs);
        setTimeout(() => {
          $scope.configs.paper.setOrigin(0, 0);
          $scope.configs.paper.translate(0, 0);
        }, 100);

        $scope.setEvents();
      }

      function resizePaper() {
        const wrapper = document.getElementById('jointpaper-wrapper');
        if (!wrapper) return;

        const laneSize = $scope.configs.swimlaneSize;
        const count    = $scope.configs.elementsCount.swimlanes;

        const svgWidth  = (laneSize.width + 1) * count;
        const svgHeight = laneSize.height;

        $scope.configs.paper.setDimensions(svgWidth, svgHeight);

        const svgEl = $scope.configs.paperElement.find('svg');
        svgEl
          .attr('width',  svgWidth  + 'px')
          .attr('height', svgHeight + 'px');
      }

      function filterMenus(menu) {
        return menu && menu.canShow();
      }

      function getElementName(item) {
        return item.name || item.attr('text/text');
      }

      function run() {
        try {
          $scope.canEdit = authService.isAdmin();
          var triggerTypes = [
            { id: 0, value: 'SEND AND REVIEW' },
            { id: 1, value: 'REVIEW' },
            { id: 2, value: 'SEND' },
          ];

          $scope.guid = $state.params.guid;

          $scope.taskTypes = [];

          $scope.endActions = [
            { id: 0, value: 'RELEASE DOCUMENT' },
            { id: 1, value: 'CANCEL FLOW' },
          ];

          $scope.flowData = {
            flowName: $filter('translate')('NEW FLOW'),
            flowDescription: '',
            triggerTypes: triggerTypes,
            triggerType: triggerTypes[0],
            documentTypeFilter: '',
          };

          $scope.title = $state.current.data.title;
          $scope.action = $state.current.data.action
            ? $state.current.data.action
            : 'edit';

          $scope.loadingUsers = false;
          $scope.loadingDocumentTypes = false;

          $scope.examples = {
            checklist: {
              saved: false,
              elementsCount: {
                swimlanes: 1,
                tasks: 1,
                decisions: 0,
                notifications: 1,
                starts: 1,
                ends: 1,
              },
              data: [
                {
                  id: '44267a90-3682-4dad-9b3d-977360ef9b10',
                  Name: 'Responsável',
                },
                { id: '7c88f059-0366-4c53-87e5-8b3d96e7728e', Name: 'Início' },
                {
                  id: '4456b896-93b6-4f65-89d5-345392418b78',
                  Name: 'Tarefa',
                  Fields: [],
                  Type: 3,
                },
                {
                  id: 'ffa1e35f-a73d-45ed-90bb-efb1b85116cb',
                  Name: 'Concluído',
                  Type: 2,
                },
              ],
              graph: {
                cells: [
                  {
                    type: 'basic.MySwimlane',
                    prop: {
                      data: {
                        type: 'swimlane',
                        index: 0,
                        children: {
                          '7c88f059-0366-4c53-87e5-8b3d96e7728e': {
                            position: { x: 89, y: 39 },
                          },
                          'ffa1e35f-a73d-45ed-90bb-efb1b85116cb': {
                            position: { x: 91, y: 373 },
                          },
                          '79d4f430-3528-4771-9635-40ee9e68c75d': {
                            position: { x: 95, y: 265 },
                          },
                          '4456b896-93b6-4f65-89d5-345392418b78': {
                            position: { x: 49, y: 163 },
                          },
                        },
                        highlight: true,
                      },
                    },
                    size: { width: 220, height: 475 },
                    position: { x: 1, y: 1 },
                    angle: 0,
                    id: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    z: -1022,
                    embeds: [
                      '24427739-d6ed-424c-a988-45a63f4c918e',
                      '3296caef-94e6-4991-bc8c-c6b6a438d5b5',
                      '79550775-fca7-4173-84ac-257af4082ce0',
                      '7c88f059-0366-4c53-87e5-8b3d96e7728e',
                      'ffa1e35f-a73d-45ed-90bb-efb1b85116cb',
                      '79d4f430-3528-4771-9635-40ee9e68c75d',
                      '4456b896-93b6-4f65-89d5-345392418b78',
                    ],
                    attrs: { text: { text: 'Responsável' } },
                  },
                  {
                    type: 'basic.Circle',
                    size: { width: 34, height: 34 },
                    position: { x: 93, y: 34 },
                    angle: 0,
                    prop: {
                      data: {
                        id: 'STR',
                        type: ETaskTypes.Start,
                        highlight: false,
                      },
                    },
                    id: '7c88f059-0366-4c53-87e5-8b3d96e7728e',
                    z: -998,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      circle: {
                        fill: {
                          type: 'linearGradient',
                          stops: [
                            { offset: '0%', color: '#F0FFFC' },
                            { offset: '100%', color: '#CFEFDF' },
                          ],
                          attrs: { x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
                        },
                        stroke: '#6C9',
                        'stroke-width': 1,
                      },
                      text: {
                        'font-size': 10,
                        text: 'Início',
                        fill: '#163',
                        'font-weight': 'lighter',
                      },
                    },
                  },
                  {
                    type: 'basic.Circle',
                    size: { width: 34, height: 34 },
                    position: { x: 93, y: 410 },
                    angle: 0,
                    prop: {
                      data: {
                        id: 'END1',
                        type: ETaskTypes.End,
                        highlight: false,
                      },
                    },
                    id: 'ffa1e35f-a73d-45ed-90bb-efb1b85116cb',
                    z: -986,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      circle: {
                        fill: {
                          type: 'linearGradient',
                          stops: [
                            { offset: '0%', color: '#EEE' },
                            { offset: '100%', color: '#CCC' },
                          ],
                          attrs: { x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
                        },
                        stroke: '#999',
                        'stroke-width': 3,
                      },
                      text: {
                        'font-size': 10,
                        text: 'Concluído',
                        'ref-y': 0.75,
                        ' y-alignment': 'bottom',
                        fill: '#777',
                        'font-weight': 'lighter',
                        ref: '.',
                        'x-alignment': 'center',
                      },
                    },
                  },
                  {
                    type: 'basic.Notification',
                    size: { width: 34, height: 34 },
                    position: { x: 93, y: 296 },
                    angle: 0,
                    prop: {
                      data: {
                        id: 'NOT1',
                        type: ETaskTypes.Notification,
                        highlight: false,
                        title: $filter('translate')('NOTIFICATION') + ' 1',
                      },
                    },
                    id: '79d4f430-3528-4771-9635-40ee9e68c75d',
                    z: -984,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      image: {
                        'xlink:href': '/assets/images/workflow/email.png',
                      },
                    },
                  },
                  {
                    type: 'link',
                    source: { id: '79d4f430-3528-4771-9635-40ee9e68c75d' },
                    target: { id: 'ffa1e35f-a73d-45ed-90bb-efb1b85116cb' },
                    connector: { name: 'normal' },
                    prop: { data: { type: 'link' } },
                    labels: null,
                    id: '79550775-fca7-4173-84ac-257af4082ce0',
                    z: -983,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      '.connection': { stroke: '#58B', 'stroke-width': 2 },
                      '.marker-target': {
                        stroke: '#58B',
                        fill: '#58B',
                        d: 'M 10 0 L 0 5 L 10 10 z',
                      },
                    },
                  },
                  {
                    type: 'basic.Rect',
                    position: { x: 50, y: 164 },
                    size: { width: 120, height: 50 },
                    angle: 0,
                    prop: {
                      data: {
                        id: 'TSK1',
                        type: ETaskTypes.Task,
                        highlight: false,
                        name: 'Tarefa',
                      },
                    },
                    id: '4456b896-93b6-4f65-89d5-345392418b78',
                    z: -978,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      rect: {
                        fill: {
                          type: 'linearGradient',
                          stops: [
                            { offset: '0%', color: '#9CF' },
                            { offset: '100%', color: '#69C' },
                          ],
                          attrs: { x1: '0%', y1: '0%', x2: '0%', y2: '100%' },
                        },
                        stroke: '#47A',
                        'stroke-width': 2,
                      },
                      text: {
                        fill: '#FFF',
                        text: 'Tarefa',
                        'font-size': 10,
                        'font-weight': 'lighter',
                      },
                    },
                  },
                  {
                    type: 'link',
                    source: { id: '4456b896-93b6-4f65-89d5-345392418b78' },
                    target: { id: '79d4f430-3528-4771-9635-40ee9e68c75d' },
                    connector: { name: 'normal' },
                    prop: { data: { type: 'link' } },
                    labels: null,
                    id: '3296caef-94e6-4991-bc8c-c6b6a438d5b5',
                    z: -977,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      '.connection': { stroke: '#58B', 'stroke-width': 2 },
                      '.marker-target': {
                        stroke: '#58B',
                        fill: '#58B',
                        d: 'M 10 0 L 0 5 L 10 10 z',
                      },
                    },
                  },
                  {
                    type: 'link',
                    source: { id: '7c88f059-0366-4c53-87e5-8b3d96e7728e' },
                    target: { id: '4456b896-93b6-4f65-89d5-345392418b78' },
                    connector: { name: 'normal' },
                    prop: { data: { type: 'link' } },
                    labels: null,
                    id: '24427739-d6ed-424c-a988-45a63f4c918e',
                    z: -976,
                    parent: '44267a90-3682-4dad-9b3d-977360ef9b10',
                    attrs: {
                      '.connection': { stroke: '#58B', 'stroke-width': 2 },
                      '.marker-target': {
                        stroke: '#58B',
                        fill: '#58B',
                        d: 'M 10 0 L 0 5 L 10 10 z',
                      },
                    },
                  },
                ],
              },
            },
          };

          $scope.configs = {
            paperElement: null,
            graph: null,
            paper: null,
            orientation: 'vertical',
            elementsCount: {
              swimlanes: 0,
              tasks: 0,
              decisions: 0,
              notifications: 0,
              starts: 0,
              ends: 0,
              releases: 0,
            },
            swimlaneSize: {
              width: 220,
              height: 475,
            },
            flow: null,
            data: [],
            examples: $scope.examples,
          };

          $scope.taskConfig = {
            position: {
              x: 50,
              y: 110,
            },
            size: {
              width: 120,
              height: 50,
            },
            prop: {
              data: {
                id: 'TSK1',
                type: ETaskTypes.Task,
              },
            },
            outPorts: ['out'],
            ports: {
              groups: {
                out: {
                  attrs: {
                    '.port-body': {
                      fill: '#E74C3C',
                    },
                  },
                },
              },
            },
            attrs: {
              rect: {
                fill: '#63a2d8',
                stroke: '#47A',
                'stroke-width': 2,
              },
              circle: {
                fill: '#F00',
              },
              text: {
                text: 'text',
                fill: '#FFF',
                'font-size': 10,
                'font-weight': 'lighter',
              },
            },
          };

          $scope.decisionConfig = {
            position: {
              x: 50,
              y: 110,
            },
            size: {
              width: 120,
              height: 80,
            },
            prop: {
              data: {
                id: 'DEC1',
                type: ETaskTypes.Decision,
              },
            },
            attrs: {
              //rect:{fill:{type:'linearGradient',stops:[{offset:'0%',color:'#9CF'},{offset:'100%',color:'#69C'}],attrs:{x1:'0%',y1:'0%',x2:'0%',y2:'100%'}},stroke:'#47A','stroke-width':2},
              text: {
                text: 'text',
                fill: '#FFF',
                'font-size': 10,
                'font-weight': 'lighter',
              },
            },
          };

          $scope.notificationConfig = {
            size: { width: 34, height: 34 },
            position: { x: 220 / 2 - 34 / 2, y: 450 / 2 - 34 / 2 },
            prop: { data: { id: 'NOT1', type: ETaskTypes.Notification } },
            attrs: {
              image: {
                'xlink:href': '/assets/images/workflow/email.png',
                x: 1,
                y: 1,
                width: 26,
                height: 26,
              },
            },
          };

          $scope.releaseConfig = {
            size: { width: 34, height: 34 },
            position: { x: 220 / 2 - 34 / 2, y: 450 / 2 - 34 / 2 },
            prop: { data: { id: 'REL1', type: ETaskTypes.ReleaseDocument } },
          };

          $scope.startConfig = {
            position: { x: 220 / 2 - 34 / 2, y: 34 },
            size: { width: 34, height: 34 },
            prop: { data: { id: 'STR', type: ETaskTypes.Start } },
            attrs: {
              circle: { fill: '#CFEFDF', stroke: '#6C9', 'stroke-width': 2 },
              text: {
                text: 'Start',
                fill: '#163',
                'font-size': 10,
                'font-weight': 'lighter',
              },
            },
          };

          $scope.endConfig = {
            size: { width: 34, height: 34 },
            prop: { data: { id: 'END1', type: ETaskTypes.End } },
            attrs: {
              circle: { fill: '#DDD', stroke: '#666', 'stroke-width': 3 },
              text: {
                text: 'End',
                fill: '#777',
                'font-size': 10,
                'font-weight': 'lighter',
                ref: '.',
                'ref-x': 0.5,
                'ref-y': 0.75,
                'x-alignment': 'center',
                'y-alignment': 'bottom',
              },
            },
          };

          $rootScope.menus = [
            {
              title: 'WORKFLOWS',
              icon: 'fa fa-sitemap fa-fw',
              class: 'm-b-20',
              action: function () {
                $state.go('flows.base.models');
              },
              type: '',
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'SWIMLANE',
              icon: 'fa fa-columns',
              action: function(type) {
                $scope.addElement(type);
              },
              type: 'swimlane',
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'TASK',
              icon: 'fa fa-list-alt',
              action: function(type) {
                $scope.addElement(type);
              },
              type: ETaskTypes.Task,
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'DECISION',
              icon: 'fa fa-question',
              action: function(type) {
                $scope.addElement(type);
              },
              type: ETaskTypes.Decision,
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'NOTIFICATION',
              icon: 'fa fa-envelope-o',
              action: function(type) {
                $scope.addElement(type);
              },
              type: ETaskTypes.Notification,
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'RELEASE DOCUMENT',
              icon: 'fa fa-unlock-alt',
              action: function(type) {
                $scope.addElement(type);
              },
              type: ETaskTypes.ReleaseDocument,
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'END',
              icon: 'fa fa-circle text-muted',
              action: function(type) {
                $scope.addElement(type);
              },
              type: ETaskTypes.End,
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'LINK',
              icon: 'fa fa-long-arrow-right',
              action: function(type) {
                $scope.addElement(type);
              },
              type: 'link',
              canShow: function () {
                return $scope.canEdit;
              },
            },
            {
              title: 'REMOVE ELEMENT',
              icon: 'fa fa-close',
              action: function () {
                $scope.removeElement();
              },
              class: 'm-t-20',
              type: '',
              canShow: function () {
                return $scope.canEdit;
              },
            },
            // A Função switchOrientation esta quebrando o layout, comentado por hora
            // {
            //   title: 'SWITCH ORIENTATION',
            //   icon: 'md md-screen-rotation',
            //   action: function () {
            //     $scope.switchOrientation();
            //   },
            //   type: '',
            //   canShow: function () {
            //     return $scope.canEdit;
            //   },
            // },
            {
              title: 'VALIDATE',
              icon: 'fa fa-check',
              action: function () {
                $scope.validate();
              },
              type: '',
              canShow: function () {
                return $scope.canEdit;
              },
            },
          ];

          $window.onbeforeunload = logWrapper(
            onbeforeunload,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.flowData.filterDocumentTypes = logWrapper(
            flowData_filterDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.filter = logWrapper(
            filter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasUsers = logWrapper(
            hasUsers,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasGroups = logWrapper(
            hasGroups,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.swimlaneHasPerson = logWrapper(
            swimlaneHasPerson,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasDocTypesAssigned = logWrapper(
            hasDocTypesAssigned,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isSelectedElementValid = logWrapper(
            isSelectedElementValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getExample = logWrapper(
            getExample,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFlow = logWrapper(
            loadFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSelection = logWrapper(
            getSelection,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.select = logWrapper(
            select,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.unselect = logWrapper(
            unselect,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validate = logWrapper(
            validate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeElement = logWrapper(
            removeElement,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addElement = logWrapper(
            addElement,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addSwimlane = logWrapper(
            addSwimlane,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addTask = logWrapper(
            addTask,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addDecision = logWrapper(
            addDecision,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addNotification = logWrapper(
            addNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addLink = logWrapper(
            addLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addStart = logWrapper(
            addStart,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addEnd = logWrapper(
            addEnd,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addReleaseDocument = logWrapper(
            addReleaseDocument,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.remove = logWrapper(
            remove,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadGroups = logWrapper(
            loadGroups,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getWorkflowData = logWrapper(
            getWorkflowData,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocumentTypes = logWrapper(
            loadDocumentTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.load = logWrapper(
            load,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getElements = logWrapper(
            getElements,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.savePositions = logWrapper(
            savePositions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadPositions = logWrapper(
            loadPositions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.switchOrientation = logWrapper(
            switchOrientation,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateConnection = logWrapper(
            validateConnection,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateEmbedding = logWrapper(
            validateEmbedding,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getParentElement = logWrapper(
            getParentElement,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.defineNewElements = logWrapper(
            defineNewElements,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getConfig = logWrapper(
            getConfig,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setConfig = logWrapper(
            setConfig,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isValid = logWrapper(
            isValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getErrorCode = logWrapper(
            getErrorCode,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getErrorMessage = logWrapper(
            getErrorMessage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setEvents = logWrapper(
            setEvents,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSave = logWrapper(
            canSave,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateDecisionsTasks = logWrapper(
            validateDecisionsTasks,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getElementById = logWrapper(
            getElementById,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.swimlaneValid = logWrapper(
            swimlaneValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.elementsValid = logWrapper(
            elementsValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.taskValid = logWrapper(
            taskValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.decisionValid = logWrapper(
            decisionValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.notificationValid = logWrapper(
            notificationValid,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validateFlow = logWrapper(
            validateFlow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getWorkflow = logWrapper(
            getWorkflow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasFlowPropertiesError = logWrapper(
            hasFlowPropertiesError,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.validityModelState = logWrapper(
            validityModelState,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showDescriptionOptionlCheckbox = logWrapper(
            showDescriptionOptionlCheckbox,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $rootScope.filterMenus = logWrapper(
            filterMenus,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
